const tradeTrustType = {
	active: "Active",
	surrendertoIssuer: "Surrendered to Issuer",
	shredded: "Shredded",
	unknown: "Unknown",
}

export default tradeTrustType
